import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BadgeCard.scss';

const BadgeCard = ({ title, desc, img }) => {
  const navigate = useNavigate();
  return (
    <div className='badge'>
      <div className='badge_info'>
        <img src={img} alt='img' className='nft_img' />

        <div className='desc'>
          <div className='badge_title'>
            {title.split(' ').map((word, index) => (
              <span key={index} style={index === 0 ? { color: '#fff' } : {}}>
                {word}{' '}
              </span>
            ))}
          </div>
          <div className='badge_desc'>{desc}</div>
        </div>
      </div>
      <button
        className='view-all'
        onClick={() => {
          window.scrollTo(0, 0);
          navigate('/badges');
        }}
      >
        View all
      </button>
    </div>
  );
};

export default BadgeCard;
